export const messages = {
  en: {
    configMenu: {
      prevStep: 'Previous',
      nextStep: 'Next',
      finish: 'Finish',
      requiredInfo: 'Please fill in the required information',
      stepTitles: {
        selectGroup: 'Select Menu Group',
        menuInfo: 'Menu Information',
        privilegeInfo: 'Privilege Information'
      }
    }
  },
  zh: {
    configMenu: {
      prevStep: '上一步',
      nextStep: '下一步',
      finish: '完成',
      requiredInfo: '请填写必选信息',
      stepTitles: {
        selectGroup: '选择菜单组',
        menuInfo: '菜单信息',
        privilegeInfo: '权限信息'
      }
    }
  }
}